<template>
  <div>
    <div class="app-toolbar1"><el-button type="primary" size="small" @click="toAdd">添加</el-button></div>
    <el-table :data="projects" :stripe="true" v-loading="loading">
      <el-table-column prop="name" label="项目名称" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="desc" label="项目描述" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="principalName" label="负责人名字" width="120"></el-table-column>
      <el-table-column prop="principalMobile" label="负责人手机号" width="120"></el-table-column>
      <el-table-column prop="principalEmail" label="负责人邮箱" width="150"></el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="155"></el-table-column>
      <el-table-column prop="updateTime" label="最后更新时间" width="155"></el-table-column>
      <el-table-column fixed="right" label="操作" width="145">
        <template slot-scope="scope">
          <el-button @click="toUpdate(scope.row)" type="primary" size="small">修改</el-button>
          <el-button @click="toDelete(scope.row)" type="danger" size="small">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :title="formTitle" :visible.sync="showForm" @close="resetForm">
      <el-form label-position="right" label-width="100px" :model="form" :rules="formRule" ref="form" :status-icon="true">
        <el-form-item label="项目名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入项目名称" :maxlength="100"></el-input>
        </el-form-item>
        <el-form-item label="项目描述" prop="desc">
          <el-input v-model="form.desc" type="textarea" placeholder="请输入项目描述" rows="4" :maxlength="200"></el-input>
        </el-form-item>
        <el-form-item label="负责人名字" prop="principalName">
          <el-input v-model="form.principalName" placeholder="请输入项目描述" :maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="负责人手机号" prop="principalMobile">
          <el-input v-model="form.principalMobile" placeholder="请输入项目描述" :maxlength="11"></el-input>
        </el-form-item>
        <el-form-item label="负责人邮箱" prop="principalEmail">
          <el-input v-model="form.principalEmail" placeholder="请输入项目描述" :maxlength="20"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="showForm = false">取 消</el-button>
        <el-button type="primary" @click="doSave">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'cg-project-manage',
  data () {
    return {
      loading: false,
      projects: [],
      showForm: false,
      formTitle: '添加项目',
      form: {
        projectId: null,
        name: null,
        desc: null,
        principalName: null,
        principalMobile: null,
        principalEmail: null,
      },
      formRule: {
        name: [{ required: true, message: '请输入项目名称', trigger: 'blur' }],
        principalMobile: [{ min: 11, max: 11, message: '必须为11位', trigger: 'blur' }]
      }
    }
  },
  created () {
    this.load()
  },
  methods: {
    load () {
      this.loading = true
      this.$http.request({
        method: 'get',
        url: '/api/cgProjects'
      }).then((res) => {
        this.projects = res.data.data
        this.loading = false
      })
    },
    toAdd () {
      this.form = { projectId: null, name: null, desc: null, principalName: null, principalMobile: null, principalEmail: null }
      this.formTitle = '添加项目'
      this.showForm = true
    },
    toUpdate (row) {
      this.formTitle = '修改项目'
      this.form = { projectId: row.projectId, name: row.name, desc: row.desc, principalName: row.principalName, principalMobile: row.principalMobile, principalEmail: row.principalEmail }
      this.showForm = true
    },
    toDelete (row) {
      this.$store.commit('confirm', { title: '提示', msg: '您确认要删除该项目吗?', data: row, scope: this, callback: this.doDelete })
    },
    doSave () {
      this.$refs.form.validate((success) => {
        if (success) {
          let projectId = this.form.projectId
          this.$http.request({
            method: !projectId ? 'post' : 'put',
            url: !projectId ? '/api/cgProjects' : `/api/cgProjects/${projectId}`,
            data: JSON.stringify(this.form)
          }).then(() => {
            this.showForm = false
            this.load()
          })
        } else {
          return false
        }
      })
    },
    doDelete (result, data) {
      if (result) {
        this.$http.request({
          method: 'delete',
          url: `/api/cgProjects/${data.projectId}`
        }).then(() => {
          this.$message.success('删除成功')
          this.load()
        })
      }
    },
    resetForm () {
      this.$refs.form.resetFields()
    }
  }
}
</script>
